import { Button, Modal } from "react-bootstrap";

const CardModal = (props) => {
	return (
		<Modal {...props} centered>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
					{props.heading}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>{props.children}</Modal.Body>
			<Modal.Footer>
				<Button
					onClick={props.submit}
					style={{ backgroundColor: "#901919", color: "#ffffff" }}
				>
					Submit
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default CardModal;
